import React from 'react';
import type { DistributedOmit } from 'type-fest';
import { MenuItem } from '../components/Menu';
import getStartedIcon from '../icons/non-prefilled/16x16/getStarted.svg';
import AvailableTutorials from '../onboarding/tutorial/AvailableTutorials';

const TutorialMenuItem = (
  props: DistributedOmit<React.ComponentProps<typeof MenuItem>, 'children'>,
) => (
  <AvailableTutorials>
    {(tutorials) => {
      if (!tutorials.length) {
        return null;
      }

      return (
        <MenuItem icon={getStartedIcon} {...props}>
          Onboarding tips
        </MenuItem>
      );
    }}
  </AvailableTutorials>
);

export default TutorialMenuItem;
